export const stickyHeader = {
  name: 'sticky-header',
  inserted: (el) => {
    const SCROLL_UP = 'scroll-up';
    const SCROLL_DOWN = 'scroll-down';
    let LAST_SCROLL = 0;
    window.addEventListener('scroll', () => {
      if (document.querySelector('body')?.classList.contains('navOpen')) {
        return;
      }
      const currentScroll = window.pageYOffset;
      if (el.classList && currentScroll <= 0) {
        el.classList.remove(SCROLL_UP);
        return;
      }
      if (currentScroll > LAST_SCROLL && !el.classList.contains(SCROLL_DOWN)) {
        // down
        el.classList.remove(SCROLL_UP);
        el.classList.add(SCROLL_DOWN);
      } else if (
        currentScroll < LAST_SCROLL &&
        el.classList.contains(SCROLL_DOWN)
      ) {
        // up
        el.classList.remove(SCROLL_DOWN);
        el.classList.add(SCROLL_UP);
      }
      LAST_SCROLL = currentScroll;
    });
    document.onkeydown = function(e) {
      if (e.keyCode == 36) {
        el.classList.remove("scroll-down");
      }
      else if (e.keyCode == 35) {
        el.classList.add("scroll-down");
      }
    };
  },
};
